module.exports = __webpack_public_path__ + "cf981facc591578af7122878ba787854.svg";


//////////////////
// WEBPACK FOOTER
// ./srv/public/img/senseware/landing-page-reports.svg
// module id = 995
// module chunks = 7